import React from "react";

export const HikeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M13.6278 5.72093C14.651 5.72093 15.4882 4.88372 15.4882 3.86047C15.4882 2.83721 14.651 2 13.6278 2C12.6045 2 11.7673 2.83721 11.7673 3.86047C11.7673 4.88372 12.6045 5.72093 13.6278 5.72093ZM17.3487 10.6326C16.2045 10.2884 15.2836 9.54419 14.744 8.60465L13.8138 7.11628C13.4324 6.51163 12.7813 6.18605 12.1022 6.18605C11.3766 6.18605 10.6231 6.65116 10.4464 7.52558C10.2696 8.4 7.58126 22 7.58126 22H9.53474L11.2092 14.5581L13.1627 16.4186V22H15.0231V15.0233L13.0696 13.1628L13.6278 10.3721C14.558 11.4419 15.8696 12.2419 17.3487 12.5488V22H18.744V8.97674H17.3487V10.6326ZM7.98126 12.8186L6.00916 12.4372C5.50684 12.3349 5.17195 11.8512 5.27428 11.3488L5.98126 7.69302C6.1766 6.68837 7.15335 6.02791 8.158 6.22326L9.23707 6.43721L7.98126 12.8186Z"
      fill="currentColor"
    />
  </svg>
);
